import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';

import { TPatientDetail } from '../../../../types/patients';
import TStore from '../../../../types/store';
import Avatar from '../../../../components/avatar';
import { memberApi } from '../../../../lib/api';
import { memberApiV2 } from '../../../../lib/api';
import { getDateFormat } from '../../../../helpers/utils-helpers';
import { ReactComponent as VideoIndicatorIcon } from '../../../../assets/svg/videocall-indicator.svg';
import { ReactComponent as CallIndicatorIcon } from '../../../../assets/svg/phonecall-indicator.svg';

const BaseInfoPatientSC = styled.div`
  display: flex;
`;

interface BaseInfoPatientProps {
  videoIndicatorStatus?: boolean;
}

const BaseInfoPatient: React.FC<BaseInfoPatientProps> = ({ videoIndicatorStatus }) => {
  const patientDetail: TPatientDetail | null = useSelector(
    (store: TStore) => store.patients.patientDetail,
  );

  const providerId = useSelector((state: TStore) => state.users.business[0].id);

  const params = useParams();

  const { userId }: any = params;
  const [lastUpdateDate, setLastUpdateDate] = useState('-');

  useEffect(() => {
    const getVdLastUpdate = async () => {
      const result = (await memberApiV2.getVitalDataLastUpdateById(providerId, userId)).data;
      const formattedDate = moment(result.data.updatedAt).format(getDateFormat());
      setLastUpdateDate(formattedDate);
    };
    getVdLastUpdate();
  }, [userId]);

  if (patientDetail === null) {
    return null;
  }

  const {
    profileImage,
    profile: { titleBeforeName, titleAfterName, firstName, lastName },
  } = patientDetail;

  return (
    <BaseInfoPatientSC>
      <div>
        <Avatar size={64} imgUrl={profileImage} />
        <div className="info-indicators">
          <div className="info-indicators__call">
            <CallIndicatorIcon />
          </div>
          <div
            className={
              videoIndicatorStatus ? 'info-indicators__video active' : 'info-indicators__video'
            }
          >
            <VideoIndicatorIcon />
          </div>
        </div>
      </div>

      <div className="info-datas">
        <h1>
          {titleBeforeName} {firstName} {lastName} {titleAfterName}
        </h1>
        <p>
          <FormattedMessage id="life_id.updated_at" values={{ date: lastUpdateDate }} />
        </p>
      </div>
    </BaseInfoPatientSC>
  );
};

export default BaseInfoPatient;
